import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    .TextInput-Root {\n        margin-top: 4px;\n        height: 40px;\n    }\n\n    .TextInput-Input {\n        height: 38px;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 48px;\n    border-right-width: 1px;\n    border-right-style: solid;\n    padding-right: ", ";\n    padding-left: ", ";\n\n    ", "\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            border-right: none;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        border-right-color: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { Search } from '../../Search';
import { HeaderNavigationItem } from '../HeaderNavigationItem';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { color, spacing } from '../../../system/mixins';
import { getPropsBlocker } from '../../../utils';

var packItemSearchStyle = function packItemSearchStyle(_ref) {
  var separator = _ref.separator;
  var result = css(_templateObject(), color('neutral.03'));

  if (!separator) {
    result = css(_templateObject2(), result);
  }

  return result;
};

export var NavigationItemSearch = styled(HeaderNavigationItem).withConfig(getPropsBlocker({}, false))(_templateObject3(), spacing(4), spacing(4), packItemSearchStyle, getComponentOverride('HeaderNavigationSearch'));
export var HeaderNavigationSearchRoot = styled(Search).withConfig(getPropsBlocker({}, false))(_templateObject4());